<template>
    <div class="page-container">
        <!-- 输入任意文本 -->
        <van-field v-model="name" :border='false' label="公司名称" placeholder="请输入公司名称" />
        <van-field v-model="shuihao" :border='false' label="企业税号" placeholder="请输入企业税号" />
        <!-- 输入手机号，调起手机号键盘 -->
        <van-field v-model="tel" type="tel" :border='false' label="注册电话" placeholder="请输入注册电话" />
        <van-field v-model="area" :disabled="true" @click="showArea = true" :border='false' label="注册地址" placeholder="请选择省/市/区" />
        <van-field
        v-model="detail"
        rows="1"
        autosize
        :border='false'
        label="详细地址"
        type="textarea"
        placeholder="街道、楼牌号等"
        />

        <div class="btn-confirm">保存</div>
        <!-- 省市区 -->
        <van-area :hidden="!showArea" @cancel="showArea = false" @confirm="confirmArea" title="请选择省市区" :area-list="areaList" />
    </div>
</template>

<script>
import { Field,Area } from 'vant'
import areaList from '../../lib/area'

export default {
    data(){
        return {
            name:'',
            shuihao:'',
            tel:'',
            area:'',
            detail:'',
            showArea:false,
            areaList:areaList,
        }
    },
    components:{
        [Field.name]:Field,
        [Area.name]:Area
    },
    methods:{
        confirmArea(result){
            let areastr=result[0].name + '/' + result[1].name + '/' + result[2].name;
            this.area=areastr;
            this.showArea=false;
        }
    }
}
</script>

<style lang="scss" scoped>
.van-cell{
    margin-bottom: 10px;
    @media screen and (max-width: 750px){
        border-radius: 4px;
    }
}
::v-deep .van-picker{
    box-shadow: 0 -1px 5px 0 #eee;
    position:fixed;
    left:0;
    bottom:0;
    width:100vw;
    z-index: 9;
}
::v-deep .van-field__control:disabled{
    color:#323233;
    -webkit-text-fill-color:#323233;
}
::v-deep .van-field__label{
    color:#323233;
}
.page-container{
    min-height:calc(100vh - 46px);
    box-sizing: border-box;
    background:#fafafa;
    padding:10px;
    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        position: fixed;
        bottom:20px;
        left:50%;
        transform: translateX(-50%);
        @media screen and (max-width:750px){
            border-radius: 26px;
        }
    }
}
</style>